export default __webpack_public_path__ + "static/tinyimage-b1bc546b8071f3cc118ab00b2e1736be.jpg";